import request from '@/utils/request'

// 查询列表
export function apiMdmItemMaintenanceMaterialsList (query) {
  return request({
    url: '/mdm/mdmItemMaintenance/materialsList',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiMdmItemMaintenanceNewExport (data) {
  return request({
    url: '/mdm/mdmItemMaintenance/v2/materialsExport',
    method: 'post',
    data: data
  })
}

// 修改
export function apiMdmItemMaintenanceMaterialsEdit (data) {
  return request({
    url: '/mdm/mdmItemMaintenance/materialsEdit',
    method: 'put',
    data: data
  })
}

// 专共用刷新
export function apiMdmItemMaintenanceMaterialsRefreshSpecializedUse () {
  return request({
    url: '/mdm/mdmItemMaintenance/refreshSpecializedUse',
    method: 'post'
  })
}
